/*
 * @Author: jiangfeng
 * @Date: 2023-03-27 15:45:20
 * @LastEditTime: 2023-03-30 14:49:13
 * @LastEditors: jiangfeng
 * @FilePath: /governance-driver-projects/packages/acceptor-center/src/utils/env.js
 */
/* eslint-disable*/
const UA = window.navigator.userAgent;
const HOST = location.hostname;
const wechatInfo = UA.match(/MicroMessenger\/([\d\.]+)/i);
const alipayInfo = UA.match(/AlipayClient\/([\d\.]+)/i);
const ChromeInfo = UA.match(/Chrome\/([\d\.]+)/i);

const isAndroid = /Android/i.test(UA);
const isIOS = /iphone|ipad|ipod|ios/i.test(UA);
const isMqq = /QQ\/([\d\.]+)/i.test(UA);
const isWechat = !!wechatInfo;
const isAlipay = !!alipayInfo;
const isDriver =
  /didigsui.*_(.+)_\d+.*/i.test(UA) ||
  /ddudriver.*_(\d+\.\d+\.\d+).*/i.test(UA);
const isPassenger = /didi.passenger.*?\/([\d.]+)/i.test(UA);
const isDchat = UA.indexOf('zhushou') >= 0;
const isQuickApp = /com.didi.quick.passenger.*?\/([\d.]+)/i.test(UA);

const Stage = [
  '10.96.79.101',
  '10.96.88.16',
  '10.96.80.113',
  'www.acceptor-test.intra.xiaojukeji.com'
];
const Pre = ['pre-acceptor.intra.didichuxing.com', '10.161.246.109'];
const Online = [
  'acceptor.xiaojukeji.com',
  '10.160.121.161',
  '10.161.246.118',
  '10.160.98.153',
  '10.161.246.142'
];

const env = {
  isAndroid,
  isIOS,
  isMqq,
  isWechat,
  isAlipay,
  isDriver,
  isPassenger,
  isDchat,
  isQuickApp,
  isDev: process.env.NODE_ENV === 'development',
  isProd: process.env.NODE_ENV === 'production',
  isStable: process.env.DKIT_APP_NODE_ENV === 'stable',
  isStage: Stage.indexOf(HOST) >= 0,
  isPre: Pre.indexOf(HOST) >= 0,
  isOnline: Online.indexOf(HOST) >= 0
};

export { env };
